module.exports = __webpack_public_path__ + "static/media/dubarry-ireland.52e02c48.png";